// implementation to allow filtering of blogs by multiple filters,
// example of currentFilters structure when filtering by tags and categories: { tags: ["tag1", "tag2"], categories: ["category1", "category2"] }
let currentFilters: Record<string, string[]> = {};

const resetFilterButton: HTMLElement = document.querySelector(
  ".ch24-blogs-noFiltersButton"
);
const filterOptions: NodeListOf<HTMLElement> = document.querySelectorAll(
  "[data-filter-value]"
);

const filterForm: HTMLFormElement = document.querySelector("#filter-form");

// get hidden form selects to update them with the selected filters. Select names must match the filterType
const formSelects: Record<string, HTMLSelectElement> = {};
filterForm
  .querySelectorAll("select")
  .forEach((select) => (formSelects[select.name] = select));

const updateFilterForm = (
  filterType: string | undefined = undefined,
  value: string | undefined = undefined
) => {
  if (filterType && value) {
    [...formSelects[filterType].options].find(
      (option) => option.value === value
    ).selected = currentFilters[filterType].includes(value);
  } else if (filterType && !value) {
    [...formSelects[filterType].options].forEach(
      // TODO make this usable for multiple input types like text, radio, etc.
      (option) => (option.selected = false)
    );
  } else {
    filterForm.reset();
  }
  filterForm.dispatchEvent(new Event("change", { bubbles: true }));
};

const updateCurrentFilters = (filterType: string, value: string) => {
  const index = (currentFilters[filterType] ?? []).indexOf(value);

  if (index !== -1) {
    currentFilters[filterType].splice(index, 1);
  } else {
    currentFilters[filterType] = [...(currentFilters[filterType] ?? []), value];
  }
};

const pushToHistory = () => {
  const url = new URL(window.location.origin + window.location.pathname);
  Object.entries(currentFilters).forEach(([filterType, values]) => {
    values.forEach((value) => {
      url.searchParams.append(filterType, value);
    });
  });
  window.history.replaceState({}, "", url);
};

const reconstructFromURL = () => {
  const url = new URL(window.location.href);
  url.searchParams.forEach((value, key) => {
    currentFilters[key] = [...(currentFilters[key] ?? []), value];
  });
};

const toggleTag = (filterOption: HTMLElement, filterType: string) => {
  filterOption.classList.toggle("ch24-badged--active");

  if (currentFilters[filterType].length === 0) {
    resetFilterButton.click();
  } else {
    resetFilterButton.classList.remove("ch24-badged--active");
  }
};

filterOptions.forEach((filterOption) => {
  filterOption.addEventListener("click", () => {
    const { filterType, filterValue } = filterOption.dataset;

    updateCurrentFilters(filterType, filterValue);
    updateFilterForm(filterType, filterValue);
    pushToHistory();

    toggleTag(filterOption, filterType);
  });
});

resetFilterButton.addEventListener("click", () => {
  filterOptions.forEach((filterOption) => {
    filterOption.classList.remove("ch24-badged--active");
  });
  resetFilterButton.classList.add("ch24-badged--active");

  currentFilters = {};
  updateFilterForm();
  pushToHistory();
});

document.addEventListener("DOMContentLoaded", () => reconstructFromURL());
